import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DistributionTypeEditor.html?raw';

import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { HTEvPlanningCommunication, HtHtEvPlanningCommunicationDistributionType, VatCodes } from "./ProgramBillingEditorTypes";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import lang from 'dojo/_base/lang';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import NumberInput from '../../moreCore/UI/NumberInput/NumberInput';

class DistributionTypeEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private sectionIsSale: HTMLElement;

    private inputVatCode: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputVatSum: MdsLax<InstanceType<typeof NumberInput>>;
    private inputPriceOfSaleGross: MdsLax<InstanceType<typeof NumberInput>>;
    private inputPriceOfSaleNet: MdsLax<InstanceType<typeof NumberInput>>;
    private inputRevenueGrossSumTotal: MdsLax<InstanceType<typeof NumberInput>>;
    private inputRevenueNetSumActual: MdsLax<InstanceType<typeof NumberInput>>;


    openEditor(data: HtHtEvPlanningCommunicationDistributionType) {
        this.setData(data);

        this.show("dlg", data.ref_distribution_type.description + " - " + data.ref_ht_evplanning_communication.$Displayname);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickOk));
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        let isForSale = this.getAttributeValue("ref_distribution_type.is_for_sale");

        if (isForSale) {
            this.hideNode(this.sectionIsSale, false);
            let isOversteered = this.getAttributeValue("is_oversteered");
            this._onChangeIsOversteered(isOversteered);
            this._loadVatCodes();
        }
    }

    private _onChangeIsOversteered(e) {
        if (e) {
            this.inputVatCode.setReadonly(false);
            this.inputPriceOfSaleGross.setReadonly(false);
        } else {
            this.inputVatCode.setReadonly(true);
            this.inputPriceOfSaleGross.setReadonly(true);

            let refHtEvPlanningCommunication = this.getAttributeValue("ref_ht_evplanning_communication") as HTEvPlanningCommunication;
            let vatCode = refHtEvPlanningCommunication.ref_vat_code;
            let priceOfSaleGross = refHtEvPlanningCommunication.price_of_sale_gross;

            this.setAttributeValue("ref_vat_code", vatCode);
            this.setAttributeValue("price_of_sale_gross", priceOfSaleGross);
        }
    }

    private _updateValues(e) {
        let newGrossPrice = this.getAttributeValue("price_of_sale_gross");
        let vatCode = this.getAttributeValue("ref_vat_code");
        let vat = vatCode.VAT_value;


        let newNetPrice = Math.round((newGrossPrice * 100) / (100 + vat) * 100) / 100;
        this.setAttributeValue("price_of_sale_net", newNetPrice);

        let quantity = this.getAttributeValue("quantity");

        let newRevenueGrossSumActual = quantity * newGrossPrice;
        let newRevenueNetSumActual = quantity * newNetPrice;
        let newVatValueActual = newRevenueGrossSumActual - newRevenueNetSumActual;

        this.setAttributeValue("VAT_value_actual", newVatValueActual);
        this.setAttributeValue("revenue_gross_sum_actual", newRevenueGrossSumActual);
        this.setAttributeValue("revenue_net_sum_actual", newRevenueNetSumActual);
    }

    protected _onChanged(attribute: string, value: any) {
        let isForSale = this.getAttributeValue("ref_distribution_type.is_for_sale")
        console.log(isForSale);
            switch (attribute) {
                case "is_oversteered":
                    if(isForSale) this._onChangeIsOversteered(value);
                    break;
                case "ref_vat_code":
                case "price_of_sale_gross":
                case "quantity":
                    if(isForSale) this._updateValues(value);
                    break;
                case "ref_communication":

            }

    }


    private _onClickOk(e) {
        this.emit("confirm", this.getCurrentData());
        this.close();
    }

    private _loadVatCodes() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__ProgramBillingEditor_GetVatCodes", {}, lang.hitch(this, this._onResponseLoadVatCodes), lang.hitch(this, this._onErrorLoadVatCodes));
    }

    private _onResponseLoadVatCodes(response: Array<VatCodes>) {
        this.StandbyStop();
        let vatCode = this.getAttributeValue("ref_vat_code");
        this.inputVatCode.setData(vatCode, response, true, "description", "ID");
    }

    private _onErrorLoadVatCodes(error) {
        console.log(error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputVatSum.setUnit("�");
        this.inputVatSum.setNumberType("currency");

        this.inputPriceOfSaleGross.setUnit("�");
        this.inputPriceOfSaleGross.setNumberType("currency");

        this.inputPriceOfSaleNet.setUnit("�");
        this.inputPriceOfSaleNet.setNumberType("currency");

        this.inputRevenueGrossSumTotal.setUnit("�");
        this.inputRevenueGrossSumTotal.setNumberType("currency");

        this.inputRevenueNetSumActual.setUnit("�");
        this.inputRevenueNetSumActual.setNumberType("currency");

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DistributionTypeEditor);